var _style, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompiling = function SvgCompiling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#CAE6FF;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm-icons-_x2F_-Code-_x2F_-Compiling"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    className: "st0",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M2.6,10.7l2.1-2.1C5.3,8,6.2,8,6.8,8.6l2.1,2.1c0.6,0.6,0.6,1.5,0,2.1l-2.1,2.1 c-0.6,0.6-1.5,0.6-2.1,0l-2.1-2.1C2,12.2,2,11.3,2.6,10.7z M14.6,10.7l2.1-2.1c0.6-0.6,1.5-0.6,2.1,0l2.1,2.1 c0.6,0.6,0.6,1.5,0,2.1l-2.1,2.1c-0.6,0.6-1.5,0.6-2.1,0l-2.1-2.1C14,12.2,14,11.3,14.6,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    className: "st2",
    d: "M8.6,16.7l2.1-2.1c0.6-0.6,1.5-0.6,2.1,0l2.1,2.1c0.6,0.6,0.6,1.5,0,2.1l-2.1,2.1 c-0.6,0.6-1.5,0.6-2.1,0l-2.1-2.1C8,18.2,8,17.3,8.6,16.7z M8.6,4.7l2.1-2.1c0.6-0.6,1.5-0.6,2.1,0l2.1,2.1c0.6,0.6,0.6,1.5,0,2.1 l-2.1,2.1c-0.6,0.6-1.5,0.6-2.1,0L8.6,6.8C8,6.2,8,5.3,8.6,4.7z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompiling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Compiling.9209b5ef.svg";
export { ForwardRef as ReactComponent };